import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M22.9 16.151v-2.12a2.11 2.11 0 0 0-2.1-2.122c-1.16 0-2.1.95-2.1 2.121v2.121m6.3-9.09H1m24 1.212V4.879c0-1.358 0-2.037-.262-2.555a2.412 2.412 0 0 0-1.048-1.06C23.176 1 22.504 1 21.16 1H4.84c-1.344 0-2.016 0-2.53.264a2.412 2.412 0 0 0-1.048 1.06C1 2.842 1 3.52 1 4.879v9.212c0 1.358 0 2.037.262 2.555.23.456.597.827 1.048 1.06.514.264 1.186.264 2.53.264h6.96M18.52 21h4.56c.672 0 1.008 0 1.265-.132.226-.116.41-.302.524-.53.131-.26.131-.599.131-1.277v-.97c0-.679 0-1.018-.13-1.278a1.206 1.206 0 0 0-.525-.53c-.257-.132-.593-.132-1.265-.132h-4.56c-.672 0-1.008 0-1.265.133-.226.116-.41.301-.524.53-.131.259-.131.598-.131 1.277v.97c0 .678 0 1.018.13 1.277.116.228.3.414.525.53.257.132.593.132 1.265.132Z"
    }, null, -1)
  ])))
}
export default { render: render }